import { render, staticRenderFns } from "./porderDetail.vue?vue&type=template&id=8c3738b4&scoped=true&"
import script from "./porderDetail.vue?vue&type=script&lang=js&"
export * from "./porderDetail.vue?vue&type=script&lang=js&"
import style0 from "./porderDetail.vue?vue&type=style&index=0&id=8c3738b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3738b4",
  null
  
)

export default component.exports